import { render } from "./thankYou.vue?vue&type=template&id=3962c698&lang=true"
import script from "./thankYou.vue?vue&type=script&lang=js"
export * from "./thankYou.vue?vue&type=script&lang=js"

import "./thankYou.vue?vue&type=style&index=0&id=3962c698&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__